import {
  SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE,
} from './constants'

export const filterSourcingSupplierInput1 = (
  search = '',
  enterEvent = null
) => ({
  type: SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1,
  searchValue: search,
  enterSearchInputFilter: enterEvent,
})
export const filterSourcingSupplierOptions2 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2,
  searchOption2: search,
  selectedOptions2: selectSearchOption,
})
export const filterSourcingSupplierOptions3 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3,
  searchOption3: search,
  selectedOptions3: selectSearchOption,
})
export const filterSourcingSupplierOptions4 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4,
  searchOption4: search,
  selectedOptions4: selectSearchOption,
})
export const filterSourcingSupplierOptionsEventType = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE,
  searchOptionEventType: search,
  selectedOptionsEventType: selectSearchOption,
})
